import { createApp } from "vue";
import * as Sentry from "@sentry/vue";
import frontendComponents from "./init";
import backendComponents from "../backend/init";
import frontendChunk from "./chunk";
import backendChunk from "../backend/chunk";
import { createI18n } from "vue-i18n";
import i18nMessages from "../../frontend/langs";
import "./bootstrap";
import "./utils/hashRefresh";
import inLocal from "./utils/inLocal";
import { webViewAppInit } from "./utils/web-view-app/init";

// Root vue component
const app = createApp();

// Sentry
if (!inLocal()) {
  Sentry.init({
    app,
    dsn: "https://84519bc610ef449487d17b92be1f6b91@o361256.ingest.sentry.io/5439893",
    environment: "production",

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // allowUrls: ["localhost", "portal.myesr.org"], // for debug only
    allowUrls: ["portal.myesr.org"],

    integrations: [
      // If you use a bundle with tracing enabled, add the BrowserTracing integration
      Sentry.browserTracingIntegration(),
      // If you use a bundle with session replay enabled, add the Replay integration
      Sentry.replayIntegration()
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

// frontend components
for (const componentName in frontendComponents) {
  const component = frontendComponents[componentName];
  app.component(component.name, component);
}

// backend components
for (const componentName in backendComponents) {
  const component = backendComponents[componentName];
  app.component(component.name, component);
}

// i18n
const i18n = createI18n({
  locale: "en", // set locale
  fallbackLocale: "en",
  messages: i18nMessages
});

frontendChunk(app);
backendChunk(app);

app.use(i18n);
app.config.globalProperties.window = window;
app.config.globalProperties.top = window;
window.App = app.mount("#app");

// for compatibility with vue2
window.App = window.App._;
window.App.$refs = window.App.refs;

// WebView
webViewAppInit();
